<ng-container>
  @if (!emptyMedia) {
    <section>
      <div class="containerFolders" style="width:600px;">
        @for (value of folder; track value) {
          <div class="m-3 mb-4 grid-item" (click)="selectFilePreview(value);">
            @if (value?.folder) {
              <div  matTooltip="{{value.folder}}" matTooltipShowDelay="900"  class="d-flex flex-column justify-content-between ">
                @if (value?.folder) {
                  <mat-card class="folder-card">
                    <div><span class="card-icon material-symbols-outlined">folder</span></div>
                  </mat-card>
                }
                <div class="text-center filename" style="margin-top:-5px;">{{value.folder}}</div>
              </div>
            }
            @if (value?.item) {
              <div matTooltip="{{value.item}}" matTooltipShowDelay="900" class="d-flex flex-column justify-content-between">
                @if (checkFileType(value) == 'image') {
                  <img [src]="storageService.getImageThumb(value)" [alt]="value.item" width="100" height="70" style="border-radius:10px; object-fit: cover;" onerror="this.src='./../../assets/img/default.jpg'">
                }
                @if (checkFileType(value) == 'file') {
                  <mat-card class="file-card">
                    <div><span class="card-icon material-symbols-outlined">draft</span></div>
                  </mat-card>
                }
                @if (checkFileType(value) === 'video') {
                  <mat-card class="video-card">
                    <img
                      [src]="storageService.getVideoThumb(value)"
                      [alt]="value.item"
                      width="100"
                      height="70"
                      class="video-thumb"
                      onerror="this.src='./../../assets/img/default.jpg'"
                      />
                    <mat-icon class="video-icon material-symbols-outlined">movie</mat-icon>
                  </mat-card>
                }
                <div class="text-center filename">{{value.item}}</div>
              </div>
            }
          </div>
        }
      </div>
    </section>
  }

  @if (emptyMedia) {
    <section>
      <p >{{'empty' | translate}}</p>
    </section>
  }

</ng-container>



